export default {
  methods: {
    loadSettlementData (page = null, pg = null) {
      // var pageUrl = ''
      // var c = JSON.parse(localStorage.user)
      var pageUrl = ''
      if (this.pagination.first_page_url && pg === 'first') {
        pageUrl += this.pagination.first_page_url
      } else if (this.pagination.last_page_url && pg === 'last') {
        pageUrl += this.pagination.last_page_url
      } else if (this.pagination.next_page_url && pg === 'next') {
        pageUrl += this.pagination.next_page_url
      } else if (this.pagination.prev_page_url && pg === 'prev') {
        pageUrl += this.pagination.prev_page_url
      } else if (this.pagination.path != null) {
        pageUrl += this.pagination.path
      } else {
        pageUrl += 'sattlement'
      }
      if (pg == null) {
        pageUrl += `?per_page=${this.per_page}`
      } else {
        pageUrl += `&per_page=${this.per_page}`
      }
      if (this.table_search) {
        pageUrl += `&searchTerm=${this.table_search}`
      }
      if (this.form.branch_id) {
        pageUrl += `&branch_id=${this.form.branch_id}`
      }
      if (this.form.settlementDate) {
        pageUrl += `&sattlementDate=${this.form.settlementDate}`
      }
      if (this.form.settlementStartDate) {
        pageUrl += `&sattlementStartDate=${this.form.settlementStartDate}`
      }
      if (this.form.settlementEndDate) {
        pageUrl += `&sattlementEndDate=${this.form.settlementEndDate}`
      }
      if (this.form.status) {
        pageUrl += `&status=${this.form.status}`
      }
      // else if (c.type === 'staff') {
      //   pageUrl += `&branch_id=${c.agent_profile.branch_id}`
      // }
      if (this.user_id) {
        pageUrl += `&member_id=${this.user_id}`
      }
      if (page != null) {
        pageUrl += `&page=${page}`
      }
      this.$axios
      .get(pageUrl, {headers: { Authorization: 'Bearer ' + localStorage.token }})
      .then((response) => response.data)
      .then((data) => {
        this.rows = data.data
        this.pagination = data.data
      })
      .catch(function (error) {
        console.log(error)
      })
      .catch(
        function (error) {
          Toast.fire({ icon: 'error', title: 'Please Try Again' })
          this.form.errors.errors = error.response.data.error
        }.bind(this)
      )
    }
  }
}



// WEBPACK FOOTER //
// ./src/mixins/SettlementRecords.js